export default __webpack_public_path__ + "img/a5aa84619881b1422e4679c11ba1901d.svg";